import isNil from 'lodash/isNil'

/**
 * @deprecated
 * use shortenWalletAddress instead
 */
export const trimWalletAddress = (walletAddress: string, offset: number = 6): string => {
  if (!walletAddress) {
    return '-'
  }

  return `${walletAddress.substr(0, offset)}...${walletAddress.substr(-offset)}`
}

// new stadarized display for wallet address
export const shortenWalletAddress = (walletAddress: string): string => {
  if (!walletAddress) {
    return '-'
  }

  return `${walletAddress.substr(0, 7)}...${walletAddress.substr(-5)}`
}

export const isEqualLowercase = (a: string, b: string): boolean => {
  if (isNil(a) || isNil(b)) return false
  return a.toLowerCase() === b.toLowerCase()
}

export const generateRandomString = (length: number): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  let result = ''
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const trimTextWithoutBreaking = (description: string, maxLength: number) => {
  if (description.length <= maxLength) {
    return description
  }

  let trimmed = description.substr(0, maxLength)
  const lastSpaceIndex = trimmed.lastIndexOf(' ')

  if (lastSpaceIndex > 0) {
    trimmed = trimmed.substr(0, lastSpaceIndex)
  }

  return trimmed
}
